<script>
    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import AssessmentTypeModel from '../../Models/assessmentTypeModel';
    import RecurringAssessmentMapping from '../../Models/recurringAssessmentMapping';
    import { handleError } from '../../Utilities/handlePromise';
    import { confirm } from '../Confirmation.svelte';
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import { notifier } from '@beyonk/svelte-notifications';

    import {groupBy, sortBy} from "lodash-es";

    let mappingList = RecurringAssessmentMapping.getList();
    let assessmentTypes = AssessmentTypeModel.getAssessmentTypeList();

    function getAssessmentTypeName(id) {
        for (let assessment_type of $assessmentTypes) {
            if (assessment_type._id == id) {
                return assessment_type.name;
            }
        }

        return "Assessment Type Not Found";
    }

    let fields = [
        {
            name: "name",
            field: "name",
            label: "Mapping Name",
            required: true
        },
        {
            field: "from",
            name: "from",
            label: "Assessment Type Source",
            formatter: getAssessmentTypeName,
            type: "select",
            required: true,
            choices: {
                static: []
            }
        },
        {
            field: "to",
            name: "to",
            label: "Assessment Type Destination",
            formatter: getAssessmentTypeName,
            type: "select",
            required: true,
            choices: {
                static: []
            }
        }
    ]

    function addMapping() {
        let formFields = JSON.parse(JSON.stringify(fields));
        let choices = $assessmentTypes.map((type) => {
            return {
                label: type.name,
                value: type._id,
                production: type.production
            }
        });

        choices = groupBy(choices, (choice) => !!choice.production);

        formFields[1].choices.static = formFields[2].choices.static = {
            groups: [
                {
                    name: "Production",
                    options: sortBy(choices[true], ['label'])
                },
                {
                    name: "Draft",
                    options: sortBy(choices[false], ['label'])
                }
            ]
        }

        formFields[1].dflt = formFields[2].dflt = choices[true][0].value;

        addFormModal({
            fields: formFields,
            title: "Add Form Mapping"
        }).then((data) => {
            RecurringAssessmentMapping.createItem(data).then(() => {
                notifier.success("Mapping Created");
            }, handleError)
        }, handleError);
    }

    function deleteMapping(mapping) {
        confirm(`Are you sure you want to delete "${mapping.name}"?`).then(() => {
            RecurringAssessmentMapping.delete(mapping._id).then(() => {
                notifier.success("Mapping Deleted");
            }, handleError)
        }, handleError)
    }
</script>

<div class="container is-fluid">
    <h1 class="title is-1">Recurring Assessment Mappings</h1>
    <Loader loading={!($mappingList && $assessmentTypes)}>
        <SortableTable sortFields={fields} tableData={$mappingList} showHideFields={false}>
            <div class="buttons is-right" slot="rowActions" let:row={mapping}>
                <button class="button is-danger" on:click={() => deleteMapping(mapping)}>Delete</button>
                <a class="button is-link" href="#/RecurringAssessmentMappings/{mapping._id}">Edit</a>
            </div>

            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success is-right" on:click={addMapping}>Create New Mapping</button>
                </div>
            </div>
        </SortableTable>
    </Loader>
</div>